const urlPrefix = `/IlocosSur/Legislative/api`;
const urlPrefixEgaps = `/Legislative/request`; //esession
let dataArray = [];
let dataArray2 = [];
let dataObject = {};
let dataObject2 = {};

const logout = () => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/egaps/logout`,
            "method": "POST",
            "headers": {
                "Content-Type": "application/json"
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}


function _arrayGroupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;

    /* const grouped = _arrayGroupBy(popData, key => key.type); */
}

const _notif = (icon, message) => { /* error success question warning */
    Swal.fire({
        icon: icon,
        html: message,
        focusConfirm: false,
        allowOutsideClick: false,
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
        },
        confirmButtonText: 'Okay'
    })
}
const _showLoading = (message) => {
    Swal.fire({
        html: '<div class="fs-3 mt-2"><i class="fas fa-spinner fa-pulse loading-icon"></i> <br> <label class="fs-5">' + (message == undefined ? "Please wait..." : (message == "" ? "Please wait..." : message)) + "</label></div>",
        showConfirmButton: false,
        allowOutsideClick: false,
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
        },
    });
}
const _hideLoading = () => {
    Swal.fire({ showConfirmButton: false }).close();
}


window.dataArray = dataArray;
window.dataArray2 = dataArray2;
window.dataObject = dataObject;
window.dataObject2 = dataObject2;
window.urlPrefix = urlPrefix;
window.urlPrefixEgaps = urlPrefixEgaps;
window._arrayGroupBy = _arrayGroupBy;
window._notif = _notif;
window._showLoading = _showLoading;
window._hideLoading = _hideLoading;

$(() => {
    $(".datepicker").datepicker({
        changeYear: true,
        changeMonth: true,
        orientation: "bottom",
    });
    $(".yearpicker").datepicker({
        changeYear: true,
        yearRange: "-50:+0",
        dateFormat: 'yy',
        showButtonPanel: true,
        onClose: function(dateText, inst) { $(this).val($("#ui-datepicker-div .ui-datepicker-year :selected").val()) }
    }).on('focus', function() {
        $(".ui-datepicker-month, .ui-datepicker-calendar, .ui-datepicker-prev, .ui-datepicker-next").hide();
        $(".ui-datepicker-year").addClass('form-control w-100 text-center');
    });


    window.onscroll = () => {
        if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
            $(".btn-scroll-top").css('display', 'block');
        } else {
            $(".btn-scroll-top").css('display', 'none');
        }
    };
    $('.overflow-auto').on('scroll', function() {
        if ($(this).scrollTop() > 1000) {
            $(".btn-scroll-top").css('display', 'block');
        } else {
            $(".btn-scroll-top").css('display', 'none');
        }
    });
    $(".btn-scroll-top").off().on('click', () => {
        window.scroll({ top: 0, behavior: "smooth" });
        $('.overflow-auto').animate({ scrollTop: 0 }, 'slow');
    });

    $('#logout').on('click', function() {
        Swal.fire({
            icon: 'question',
            html: "Are you sure you want to logout from the system?",
            showDenyButton: true,
            confirmButtonText: 'YES',
            denyButtonText: `NO `,
        }).then((result) => {
            if (result.isConfirmed) {
                logout().then((data) => {
                    if (data.success) {
                        window.location = data.link;
                    }
                })
            }
        })
    });

    $('.nav-item.dropdown .dropdown-menu').on('click', function(event) {
        event.stopPropagation();
    });

    $(window).resize(function() {

        if ($(window).width() > 768) {
            $('.sidebarCollapse-btn').trigger('click')
        }
        $('.dataTable').DataTable().columns.adjust().draw();
    })
});